import { NgModule } from '@angular/core';
import { TableRowMovementDirective } from './table-row-movement';

@NgModule({
  declarations: [TableRowMovementDirective],
  imports: [],
  exports: [TableRowMovementDirective],
})
export class MatRowKeyboardSelectionModule {}
